import { IsNotEmpty } from 'class-validator';

export class ReferencePatent {
  @IsNotEmpty()
  patent!: string;

  @IsNotEmpty()
  paragraph!: string;

  @IsNotEmpty()
  content!: string;
}
